import { SxProps } from '@mui/material';
import { black, blue, grey4, grey8, red2, red3 } from 'app/components/ThemeProvider/colors';

export const infoText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '26px',
  mb: '12px',
  fontWeight: '600',
};
export const descText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '17px',
  mb: '34px',
  fontWeight: '400',
  color: grey8,
};

export const code: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '32px',
  fontWeight: '400',
  color: black,
  padding: '6px 24px',
  background: grey4,
  width: '119px',
  borderRadius: '10px',
  display: 'flex',
  justifyContent: 'center',
};

export const warningBox: SxProps = {
  display: 'flex',
  alignItems: 'center',
  p: '14px 16px',
  border: `1px solid ${red2}`,
  borderRadius: '10px',
  background: red3,
  mt: '28px',

  '@media screen and (max-height: 864px)': {
    mt: '24px',
  },
};

export const errorText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '14px',
  color: black,
};

export const countBox: SxProps = {
  display: 'flex',
  mt: '28px',
};

export const infoTextTimer: SxProps = {
  mr: '5px',
  color: grey8,
  fontSize: '18px',
  fontFamily: 'Yelo',
};

export const timer: SxProps = {
  color: black,
  fontSize: '18px',
  fontFamily: 'Yelo',
};

export const resent: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '15px',
  fontWeight: '400',
  color: blue,
  mt: '28px',
  cursor: 'pointer',
  p: 0,
};
